export const fieldIsEmpty = (fieldValue) => {
  if (!fieldValue) return true;
  return false;
};

export const emailHasErrors = (email) => {
  if (/^\w+([\+\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,63})+$/.test(email)) {
    return false;
  }
  return true;
};

export const textHasErrors = (text) => {
  if (!text || text.length < 2) {
    return true;
  }
  return false;
};

export const addressHasErrors = (str) => {
  if (/^(P[O|0]\s\#|BOX\s\#|(P[\.|\s]?[O|0][\s|\.|s].*\bBOX))/gi.test(str)) {
    return true;
  }
  return false;
};
